// Comércio — varejo, loja, pequeno negócio, serviços
// Vermelho vibrante + branco, energia e ação
module.exports = {
  effect: 'none',
  colors: {
    main:            { light: '#fff8f5', dark: '#1a0d00' },
    card:            { light: '#ffeee8', dark: '#241208' },
    surface:         { light: '#ffd9cc', dark: '#2e1810' },
    action:          { light: '#c0392b', dark: '#ff6b5b' },
    actionHover:     { light: '#9b2d20', dark: '#ff5242' },
    textPrimary:     { light: '#1a0d00', dark: '#fff8f5' },
    textSecondary:   { light: '#3d1a10', dark: '#ffd4c8' },
    textMuted:       { light: '#8b4040', dark: '#ff9980' },
    textMutedSubtle: { light: '#b06050', dark: '#b06050' },
    border:          { light: '#e8a090', dark: '#4a2018' },
    borderSubtle:    { light: '#f5c4b8', dark: '#381408' },
    link:            { light: '#c0392b', dark: '#ff6b5b' },
    linkBg:          { light: '#fff0ed', dark: 'rgba(192,57,43,0.15)' },
    linkBorder:      { light: '#ffbbb0', dark: '#c0392b' },
    linkHover:       { light: '#ffe4de', dark: 'rgba(192,57,43,0.28)' },
    inputBg:         { light: '#ffffff', dark: '#241208' },
    inputBorder:     { light: '#e8a090', dark: '#4a2018' },
    inputText:       { light: '#1a0d00', dark: '#fff8f5' },
    focusRing:       { light: '#c0392b', dark: '#ff6b5b' },
    overlay:         { light: 'rgba(0,0,0,0.5)', dark: 'rgba(0,0,0,0.75)' },
    confirm:         { light: '#8b4040', dark: '#4a2018' },
    confirmHover:    { light: '#6b2828', dark: '#5a2c1c' },
    confirmText:     { light: '#ffffff', dark: '#fff8f5' },
    confirmBg:       { light: '#fff8f5', dark: '#241208' },
    confirmBorder:   { light: '#f5c4b8', dark: '#4a2018' },
    success:         { light: '#065f46', dark: '#34d399' },
    successHover:    { light: '#022c22', dark: '#10b981' },
    successBg:       { light: '#ecfdf5', dark: 'rgba(6,78,59,0.3)' },
    successText:     { light: '#10b981', dark: '#6ee7b7' },
    successBorder:   { light: '#a7f3d0', dark: '#065f46' },
    error:           { light: '#b91c1c', dark: '#f87171' },
    errorHover:      { light: '#991b1b', dark: '#ef4444' },
    errorBg:         { light: '#fef2f2', dark: 'rgba(127,29,29,0.3)' },
    errorText:       { light: '#ef4444', dark: '#fca5a5' },
    errorBorder:     { light: '#fecaca', dark: '#7f1d1d' },
    info:            { light: '#1e40af', dark: '#60a5fa' },
    infoHover:       { light: '#1d4ed8', dark: '#3b82f6' },
    infoBg:          { light: '#eff6ff', dark: 'rgba(30,58,138,0.3)' },
    infoText:        { light: '#3b82f6', dark: '#93c5fd' },
    infoBorder:      { light: '#bfdbfe', dark: '#1e3a8a' },
  },
  borderRadius: {
    card:      '20px',
    container: '14px',
    page:      '18px',
    button:    '9999px',
    input:     '12px',
    badge:     '8px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '4px',
    device:  '6px',
  },
  textures: {
    main:    { light: '', dark: '', size: '0', blendLight: 'normal', blendDark: 'normal', opacityLight: 0, opacityDark: 0 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
